namespace Roodik.Core
{
	export class Scene extends PIXI.Container
	{
		protected readonly GAME_WIDTH : number = 1280;
		protected readonly GAME_HEIGHT : number = 960;
		
		protected readonly _renderer : PIXI.WebGLRenderer | PIXI.CanvasRenderer;
		private _isPortrait : boolean = false;
		private _parentContainer: any;

		constructor(protected _htmlElement : HTMLElement, styleSheet)
		{
			super();
			this._parentContainer = _htmlElement;
			this.addFonts(styleSheet);
			
			let pixelRatio = window.devicePixelRatio || 1;
			let rendererOptions = {
				autoResize:true,
				antialias:true,
				transparent:true,
				backgroundColor:0xffffff,
				resolution:pixelRatio
			};
			this._renderer = <PIXI.WebGLRenderer>PIXI.autoDetectRenderer(this.GAME_WIDTH, this.GAME_HEIGHT, rendererOptions);

			this._parentContainer.insertAdjacentElement("afterbegin", this._renderer.view);
			this._renderer.view.draggable = false;
			this._renderer.view.style['-webkit-user-select'] = 'none';
			this._renderer.view.style['-khtml-user-select'] = 'none';
			this._renderer.view.style['-moz-user-select'] = 'none';
			this._renderer.view.style['-ms-user-select'] = 'none';
			this._renderer.view.style['user-select'] = 'none';
			this._renderer.view.style['outline'] = 'none';
			this._renderer.view.style['-webkit-tap-highlight-color'] = 'rgba(255, 255, 255, 0)';

			window.addEventListener("orientationchange", this.resize.bind(this), false);
			window.addEventListener("resize", this.resize.bind(this), false);
			window.addEventListener("onresize", this.resize.bind(this), false);

			this.updateInternal();
			this.resize();
			
			PIXI.settings.SCALE_MODE = PIXI.SCALE_MODES.LINEAR;
			PIXI.ticker.shared.add(this.updateInternal, this);
		}
		
		private addFonts(styleSheet)
		{
			if(styleSheet)
			{
				let baseUrl = (window["cdnUrl"] == null || window["cdnUrl"] == undefined) ? "" : window["cdnUrl"];
				let fontsCss = styleSheet.split("%RESOURCEPATH%").join(baseUrl + "resources/");
				let head = document.head || document.getElementsByTagName('head')[0];
				let style = <any>document.createElement('style');
				
				style.type = 'text/css';
				if (style.styleSheet)
				{
					style.styleSheet.cssText = fontsCss;
				}
				else {
					style.appendChild(document.createTextNode(fontsCss));
				}
				head.appendChild(style);
			}
		}
		
		private updateInternal()
		{
			Roodik.Core.Tween.Tween.update();
			this._renderer.render(this);
			this.update();
		}
		
		private resize()
		{
			let isMobile = window["mode"] == "mobile" || window["mode"] == undefined;
			if (isMobile)
			{
				if (window.innerHeight > window.innerWidth) {
					this.setPortrait();
				} else {
					this.setLandscape();
				}
			}

			let newWidth;
			let newHeight;
			if (!this._isPortrait)
			{
				newWidth = this._parentContainer.clientWidth;
				newHeight = newWidth * this.GAME_HEIGHT / this.GAME_WIDTH;
				if (isMobile)
				{
					newHeight = Math.min(newHeight,this._parentContainer.clientHeight)
				}
			}
			else
			{
				newHeight = this._parentContainer.clientHeight;
				newWidth = newHeight * this.GAME_WIDTH / this.GAME_HEIGHT;
				if (isMobile)
				{
					newWidth = Math.min(newWidth,this._parentContainer.clientWidth)
				}
			}

			this._renderer.resize(newWidth, newHeight);

			let scaleX;
			let scaleY;
			if (this._isPortrait)
			{
				scaleX = newWidth / this.GAME_HEIGHT;
				scaleY = newHeight / this.GAME_WIDTH;
			}
			else
			{
				scaleX = newWidth / this.GAME_WIDTH;
				scaleY = newHeight / this.GAME_HEIGHT;
			}
			this.scale.x = this.scale.y = Math.min(scaleX,scaleY);
			this.x = newWidth *.5;
			this.y = newHeight *.5;
		}

		private setLandscape()
		{
			if (this._isPortrait)
			{
				this._isPortrait = false;
				this.rotation = 0;
			}
		}

		private setPortrait()
		{
			if (!this._isPortrait)
			{
				this._isPortrait = true;
				this.rotation = (90*Math.PI)/180;
			}
		}

		protected update()
		{
		}
	}
}


// WEBPACK FOOTER //
// /source/src/typescript/Core/Base/Scene.ts